<template>
    <div>
        <div class="app-title">
            <div>
                <h2>{{$t('tlt.electrodeDischargePlanList')}}</h2>
                <ul class="app-breadcrumb breadcrumb">
                    <li class="breadcrumb-item"><router-link to="/"><i class="fa fa-home"></i></router-link></li>
                    <li class="breadcrumb-item"><router-link to="/prd/electrodeDischargePlan"><span>{{$t('tlt.electrodeDischargePlanList')}}</span></router-link></li>
                </ul>
            </div>
            <div class="col-lg-4">
                <div class="float-lg-right">
                    <button class="btn btn-outline-primary" v-on:click="MMFNew('electrodeDischargePlan')">
                        <i class="fa fa-fw fa-lg fa-plus"></i>
                        <span class="text">{{ $t("btn.basic.add") }}</span>
                    </button>
                </div>
            </div>
        </div>

        <section class="app-content">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <mes-filter entity="electrodeDischargePlan" />
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <div id="electrodeDischargePlanListTabel" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo" data-parent="#accordionResult">
                        <div class="card-body">
                            <mmf-table entity="electrodeDischargePlan" inline-actions-disabled singleChoice>
                                <div slot="btnList" class="btn-group">
                                    <button v-bind:class="'btn btn-outline-primary btn-sm'" v-on:click="jumpToDropWeight()">
                                        <i class="fas fa-tasks"></i>
                                        <span class="text">{{$t('tlt.pressureDropWeightChange')}}</span>
                                    </button>
                                    <button v-bind:class="'btn btn-outline-primary btn-sm'" v-on:click="jumpToReleasedElectrodePara()">
                                        <i class="fas fa-tasks"></i>
                                        <span class="text">{{$t('tlt.releasedElectrodePara')}}</span>
                                    </button>
                                    <button v-bind:class="'btn btn-outline-primary btn-sm'" v-on:click="jumpToElectrodeResistance()">
                                        <i class="fas fa-tasks"></i>
                                        <span class="text">{{$t('tlt.electrodeResistance')}}</span>
                                    </button>
                                </div>
                            </mmf-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { createHelpers } from "vuex-map-fields";
import {
  gridFields,
  filterFields
} from "@/model/prd/productionExecution/smelting/ElectrodeDischargePlan";
import MmfTable from "@/components/MmfTable";
import MesFilter from '@/components/MesFilter'

// create a helper to generate getters and setters with namespace
const { mapFields } = createHelpers({
  getterType: "electrodeDischargePlan/getField",
  mutationType: "electrodeDischargePlan/updateField"
});
export default {
    name: "electrodeDischargePlanList",
    data(){
      return {

      }
    },
    components: { MmfTable, MesFilter },
    computed: {
    // generate and add getters and setters using the filter names defined in
    // entity model
    ...mapFields(filterFields),
    ...mapState({
      rows: state => state.electrodeDischargePlan.rows,
      tableColumns: gridFields,
      entity: state => state.electrodeDischargePlan.entity,
      checkedItems: state => state.electrodeDischargePlan.checkedItems,
      showNoResultAlert: state => state.base.showNoResultAlert
    })
    },
    methods: {
    ...mapActions("base", [
      "MMFselectRow",
      "MMFselectAllRows",
      "MMFNew",
      "MMFEdit",
      "MMFLoadRows",
      "MMFDelete",
      "MMFClearFilter"
    ]),
    jumpToDropWeight() {
        this.$router.push("/prd/pressureDropWeightChange");
    },
    jumpToReleasedElectrodePara() {
        this.$router.push("/prd/releasedElectrodePara");
    },
    jumpToElectrodeResistance() {
        this.$router.push("/prd/electrodeResistance");
    }
    },
    mounted() {}
}
</script>